module.exports = __webpack_public_path__ + "static/join-4181a753c8f304dad28142a54ecf32a0.svg";